const CustomLabels = ({ texts }) => {
    return (
        <label className="text-sm font-medium relative inline-block mb-3">
            {texts}
            <span className="absolute h-[14px] bg-orange-100 left-[-8px] -bottom-0.5 w-[calc(100%+16px)] -z-10"/>
        </label>
    )
}

export default CustomLabels;